import { tv } from "@/utils/tv.config";

export const cardActionsClasses = tv({
  base: ["Card__action", "p-5", "pt-0"],
  variants: {},
});
